import { render, staticRenderFns } from "./EducationFields.vue?vue&type=template&id=0c139bec"
import script from "./EducationFields.vue?vue&type=script&lang=js"
export * from "./EducationFields.vue?vue&type=script&lang=js"
import style0 from "./EducationFields.vue?vue&type=style&index=0&id=0c139bec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports